import { ReportMenuType, ReportType } from 'src/models';

import EnergyIcon from 'src/assets/icons/energy-icon.svg';
import FinancialIcon from 'src/assets/icons/financial-icon.svg';
import MaintenanceIcon from 'src/assets/icons/maintenance-icon.svg';
import SettingsIcon from 'src/assets/icons/settings-icon.svg';

export const getIconReportTemplate = (reportType: ReportMenuType) => {
  switch (reportType) {
    case ReportType.DELIVERED_ENERGY:
      return EnergyIcon;
    case ReportType.FINANCIAL:
      return FinancialIcon;
    case ReportType.MAINTENANCE_SCHEDULE:
      return MaintenanceIcon;
    default:
      return SettingsIcon;
  }
};

export const getDescriptionReportTemplate = (
  reportType: ReportMenuType,
  availableTimePeriods: string[]
) => {
  const periodsText = getTimePeriodsText(availableTimePeriods);

  switch (reportType) {
    case ReportType.MAINTENANCE_SCHEDULE:
      return `Generate ${periodsText} schedule`;
    default:
      return `Generate ${periodsText} reports`;
  }
};

const getTimePeriodsText = (periods: string[]): string => {
  if (!periods || periods.length === 0) return '';

  if (periods.includes('All')) {
    return 'report of entire';
  }

  if (periods.length > 1) {
    return periods.map((period) => period.toLowerCase()).join(' or ');
  }

  return periods[0].toLowerCase();
};
